/** Direct entry, dev override, and debug flags — the things ever read from the URL. */
export interface BootParams {
  venueRef: string | null;
  legacyVenuePath: boolean;
  devKey: string | null;
  /**
   * Client-side only — skips the inline geofence check so the Request button behaves as if
   * presence were already proven. Never bypasses the server's own check on `POST /requests`;
   * a debug session out of range still gets a real `outside_geofence` rejection.
   */
  debugSkipGeofence: boolean;
}

export function readBootParams(search: string, pathname: string): BootParams {
  const params = new URLSearchParams(search);
  const pathMatch = pathname.match(/^\/(JUKE[0-9]+)\/?$/i);
  return {
    venueRef: params.get("venue") || pathMatch?.[1] || null,
    legacyVenuePath: Boolean(pathMatch),
    devKey: params.get("dev"),
    debugSkipGeofence: params.get("debug_skip_geofence") === "1",
  };
}

/**
 * Keeps the URL's `?venue=` in sync with whichever venue is currently active, however it was
 * resolved (Direct, Resume, Find Me, or search). This makes the address bar a live reflection of
 * the current venue and a quick dev override — edit `?venue=` and reload to switch venues without
 * searching.
 */
export function writeVenueRefToUrl(venueRef: string | null): void {
  const url = new URL(window.location.href);
  if (venueRef) {
    url.searchParams.set("venue", venueRef);
  } else {
    url.searchParams.delete("venue");
  }
  window.history.replaceState(window.history.state, "", url);
}
